const searchBannerSlideAdapter = (data) => {
  if (!data) return;

  const { icon } = data;

  return {
    title: data.title,
    content: data.content,
    icon: icon && {
      id: icon.id,
      original: icon.original,
    },
  };
};

const searchBannerAdapter = (data) => {
  if (!data) return;

  const { video_desktop, video_mobile, image_desktop, image_mobile } = data;

  return {
    uuid: data.uuid,
    url: data.url,

    videoDesktop: {
      id: video_desktop.id,
      original: video_desktop.original,
    },
    videoMobile: {
      id: video_mobile.id,
      original: video_mobile.original,
    },

    imageDesktop: {
      id: image_desktop.id,
      original: image_desktop.original,
    },
    imageMobile: {
      id: image_mobile.id,
      original: image_mobile.original,
    },

    slides: data.slides?.length
      ? data.slides.map(searchBannerSlideAdapter)
      : [],
  };
};

export const searchBannersAdapter = (data) => {
  return data.map(searchBannerAdapter);
};
